module.exports = __webpack_public_path__ + "static/img/menage11.1b074337.jpg";